const validateEmail = email => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};

export const validateNewForm = values => {
  const errors = {};
  if (!values.siteUrl) {
    errors.siteUrl = 'Required';
  }
  if (!values.siteName) {
    errors.siteName = 'Required';
  }
  if (!Object.keys(values.asanaProject)?.length) {
    errors.asanaProject = 'Required';
  }
  if (values.subscribers?.length) {
    for (const email of values.subscribers) {
      if (!validateEmail(email)) {
        errors.subscribers = 'One or more email addresses are invalid';
        break;
      }
    }
  }
  if (!values.formTitle) {
    errors.formTitle = 'Required';
  }
  if (values.formFields?.length) {
    const formFieldErrors = [];

    values.formFields.forEach((field, index) => {
      const fieldErrors = {};

      if (!field.label) {
        fieldErrors.label = 'Required';
      }
      if (!field.type) {
        fieldErrors.type = 'Required';
      }
      if (field.type === 'dropdown') {
        const validOptions = field.options?.filter(opt => opt.trim() !== '');
        if (!validOptions || validOptions.length === 0) {
          fieldErrors.options = 'Dropdown must have at least one option';
        }
      }
      if (field.type === 'number') {
        if (field.min !== '' && field.max !== '' && parseFloat(field.min) > parseFloat(field.max)) {
          fieldErrors.min = 'Min cannot be greater than max';
        }
      }
      if (Object.keys(fieldErrors)?.length) {
        formFieldErrors[index] = fieldErrors;
      }
    });

    if (formFieldErrors?.length) {
      errors.formFields = formFieldErrors;
    }
  }
  return errors;
};
